'use client'

import { Skeleton } from "@/components/ui";
import { useSelector } from "react-redux";
import { DateSelectionSkeleton, Dates, Times } from "./components";
import { useDateTime } from "./hooks";

interface TProps {
    eventInfo: any;
    onNext: () => void;
}

const DateTimeSelection = ({ eventInfo, onNext }: TProps) => {
    const cartData = useSelector(
        (state: any) => state?.user?.cart,
    );
    const {
        loading,
        dates,
        datesError,
        times,
        timesLoading,
        handleSelectDate,
        handleSelectTime,
        retryFetchDates,
    }: any = useDateTime({ eventId: eventInfo?._id, eventCode: eventInfo?.eventCode, cartData, onNext });

    return (
        <div className="w-full max-w-2xl p-4">
            <div className='mb-4 w-full max-w-2xl rounded-xl border bg-white p-3 text-center font-bold text-gray-800 uppercase'>
                {loading ? (
                    <Skeleton className='mx-auto h-5 w-[12rem] md:h-6' />
                ) : (
                    <p>Select Date</p>
                )}
            </div>
            <div className='mb-20 w-full max-w-2xl min-h-84 rounded-lg'>
                {loading ? (
                    <DateSelectionSkeleton />
                ) : datesError ? (
                    <div className='mt-4 flex w-full flex-col items-center gap-3 text-center text-gray-500'>
                        <p>Couldn&apos;t load available dates.</p>
                        <button
                            type='button'
                            onClick={retryFetchDates}
                            className='rounded-lg bg-zinc-900 px-4 py-2 text-sm font-medium text-white hover:bg-zinc-800'
                        >
                            Try again
                        </button>
                    </div>
                ) : (
                    <>
                        <Dates
                            dates={dates}
                            selectedDate={cartData?.selectedDate?.date}
                            handleSelectDate={handleSelectDate}
                        />

                        {timesLoading ? (
                            <div className='mt-2 flex flex-col gap-2'>
                                <Skeleton className='h-5 w-28' />
                                <div className='grid grid-cols-2 gap-2 sm:grid-cols-3'>
                                    {Array.from({ length: 3 }).map((_, index) => (
                                        <Skeleton key={index} className='h-12 w-full rounded-lg' />
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <Times
                                selectedDate={cartData?.selectedDate?.date}
                                times={times}
                                handleSelectTime={handleSelectTime}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default DateTimeSelection;
